import React from "react";
import { Routes, Route } from "react-router-dom";
import ListReferral from "../Components/Referrals/listReferral";
import SignupListReferrals from "../Components/Referrals/signupReferral";
import ReferralHeader from "../Components/Referrals/referralHeader";
import ViewReferral from "../Components/Referrals/viewReferral";
import AddReferral from "../Components/Referrals/addReferral";

const ReferralsRoutes = () => {
  return (
    <Routes>
      <Route
        path="/referrals"
        element={<ReferralHeader></ReferralHeader>}
      ></Route>
      <Route
        path="/booking_referrals"
        element={<ListReferral></ListReferral>}
      ></Route>
      <Route
        path="/signup_referrals"
        element={<SignupListReferrals></SignupListReferrals>}
      ></Route>
      <Route
        path="/referrals/view/:id"
        element={<ViewReferral></ViewReferral>}
      ></Route>
      <Route
        path="/referrals/add"
        element={<AddReferral></AddReferral>}
      ></Route>
    </Routes>
  );
};

export default ReferralsRoutes;
